<template>
  <Popover
    :header="help.header"
    :title="help.title"
    :message="help.message"
    :helpLink="help.link"
    :testId="testId"
  >
    <font-awesome-icon :icon="help.icon || 'fa-regular fa-circle-question'" class="tw-ml-1" />
  </Popover>
</template>

<script>
import Popover from "@/components/display/Popover";

export default {
  name: "LearnMore",
  components: { Popover },
  props: {
    help: {
      type: Object,
      required: true,
    },
    testId: String,
  },
};
</script>
